module.exports = __webpack_public_path__ + "img/theme12.6e87a1f8.png";